import { render, staticRenderFns } from "./AAsignarDocente.vue?vue&type=template&id=3a11bca0"
import script from "./AAsignarDocente.vue?vue&type=script&lang=js"
export * from "./AAsignarDocente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports